import ReactModal from 'react-modal';

import { ZoomComponentModalCloseButton } from 'approot/activity-builder/activity-builder-zoom-component-modal';
import { ModalBaseCss } from 'lib/modal/modal.constants';
import {
  SimpleModalContainerStyled,
  SimpleModalContentStyled,
} from 'lib/modal/simple-modal.styles';
import { ComponentAspectRatio } from '../shared/component-height/component-dimensions';
import { ComponentAbsoluteWrapper } from '../shared/component-height/component-dimensions.style';
import { getStimulusLabel } from '../shared/logic/get-stimulus-label';
import * as Styled from './interactive.style';
import { StimulusResourceType } from 'global/constants';
import InteractiveDownloadGuidedReadThroughs from 'approot/interactive/interactive-guided-read-throughs-download';
import type { GetStimulusResourceQuery } from '../../../shared/stimulus/stimulus.graphql.generated';
import { spacing16 } from 'approot/shared/styles/spacing.style';
import type { Pluck } from 'lib/gql/pluck';

type Props = {
  type: StimulusResourceType;
  stimulusLink: string;
  onClose: () => void;
  guidedReadThroughs?: {
    resources: Pluck<
      Extract<
        Pluck<GetStimulusResourceQuery, 'getStimulusResource'>,
        { __typename: 'StimulusResourceEBookInteractive' }
      >,
      'guidedReadThroughs'
    >[];
    stimulusResourceId?: number;
  };
};

const InteractiveExpandModal = ({
  type,
  stimulusLink,
  onClose,
  guidedReadThroughs,
}: Props) => {
  const customStyles = {
    ...ModalBaseCss,
    content: {
      ...ModalBaseCss.content,
      maxWidth: '1128px',
      inset: '50% auto auto',
      transform: 'translateY(-50%)',
    },
  };

  return (
    <ReactModal
      isOpen
      onRequestClose={onClose}
      style={customStyles}
      contentLabel="Interactive expand modal"
      bodyOpenClassName="ReactModal__Body--open"
    >
      <ZoomComponentModalCloseButton
        aria-label="Close interactive expand modal"
        onClick={onClose}
      />
      <SimpleModalContainerStyled
        $scrollWithinModal
        $isOverflowable
        $isHeadless
      >
        <Styled.InteractiveExpandModalInner>
          <SimpleModalContentStyled>
            <ComponentAspectRatio dimensions={{ width: 16, height: 9 }}>
              <ComponentAbsoluteWrapper>
                <Styled.InteractiveViewport>
                  <Styled.InteractiveViewportInner>
                    <iframe
                      allow="fullscreen"
                      allowFullScreen
                      title={getStimulusLabel(type)}
                      src={stimulusLink}
                      scrolling="no"
                    />
                  </Styled.InteractiveViewportInner>
                </Styled.InteractiveViewport>
              </ComponentAbsoluteWrapper>
            </ComponentAspectRatio>
            {guidedReadThroughs?.stimulusResourceId && (
              <InteractiveDownloadGuidedReadThroughs
                guidedReadThroughs={guidedReadThroughs.resources}
                stimulusResourceId={guidedReadThroughs.stimulusResourceId}
                marginTop={spacing16}
              />
            )}
          </SimpleModalContentStyled>
        </Styled.InteractiveExpandModalInner>
      </SimpleModalContainerStyled>
    </ReactModal>
  );
};

export default InteractiveExpandModal;
